import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { StepperProvider } from './context/stepperContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
  // <PayPalScriptProvider options={{ "client-id": "AQCAw1zslyc7A5xvNgmfIZ29kLg_MqrOVlAJ-i06cIWnZ6G2IaiMlVD97gQ0hIxHRsyw5LyVjy-7W1hU" }}>
  // {/* // <React.StrictMode> */}
  
  // {/* // </React.StrictMode> */}
  // </PayPalScriptProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
